{
  "columns": {
    "actions": "Voir la facture",
    "amount": "Montant",
    "issueDate": "Envoyé le",
    "reference": "Référence"
  },
  "intlCurrency": "{{ value, currency(currency: EUR)}}",
  "title": "Mes Factures"
}
